export const NUM_RESULTS_PER_PAGE = 20

export interface JobSearchStateProps {
  searchText: string
  source: {}
  company_name: {}
  company_group: {}
  company_industry: {}
  company_is_public: {}
  is_accepts_anonymous_application: boolean
  state: {}
  city: {}
  remote: {}
  country: {}
  title: {}
  location: {}
  selectedJob: any
  gt_posted_at: any
  lt_posted_at: any
  gt_revenue_per_apply: any
  lt_revenue_per_apply: any
  gt_revenue_per_click: any
  lt_revenue_per_click: any
  gt_revenue_per_hire: any
  lt_revenue_per_hire: any
  sort: string
  sortDirection: 'desc' | 'asc'
  userRid: string
}

export const INITIAL_SEARCH_STATE: JobSearchStateProps = {
  searchText: '',
  source: {},
  company_name: {},
  company_group: {},
  company_industry: {},
  company_is_public: {},
  is_accepts_anonymous_application: false,
  state: {},
  city: {},
  remote: {},
  country: {},
  title: {},
  location: {},
  selectedJob: null,
  gt_posted_at: null,
  lt_posted_at: null,
  gt_revenue_per_apply: null,
  lt_revenue_per_apply: null,
  gt_revenue_per_click: null,
  lt_revenue_per_click: null,
  gt_revenue_per_hire: null,
  lt_revenue_per_hire: null,
  sort: 'relevancy',
  sortDirection: 'desc',
  userRid: null,
}

export const SEARCH_ATTRIBUTES_USING_OBJ = [
  'company_name',
  'company_group',
  'company_industry',
  'company_is_public',
  'country',
  'state',
  'location',
  'remote',
  'source',
]
